import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import Modal, { ModalBody, ModalFooter } from './Modal';
import Button from './Button';
import { useUIStore } from '../../stores';
import { useTranslation } from 'react-i18next';

export default function ConfirmDialog() {
  const { t } = useTranslation();
  const { confirmDialog, hideConfirm } = useUIStore();
  
  if (!confirmDialog) return null;
  
  const {
    title,
    message,
    confirmText = t('common.confirm'),
    cancelText = t('common.cancel'),
    variant = 'danger',
    onConfirm,
    onCancel
  } = confirmDialog;
  
  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    hideConfirm();
  };
  
  const handleCancel = () => {
    if (onCancel) onCancel();
    hideConfirm();
  };
  
  return (
    <Modal isOpen={true} onClose={handleCancel} size="sm">
      <ModalBody>
        <div className="flex items-start gap-4">
          <div className={`p-2 rounded-full ${variant === 'danger' ? 'bg-danger-100' : 'bg-accent-100'}`}>
            <ExclamationTriangleIcon className={`w-6 h-6 ${variant === 'danger' ? 'text-danger' : 'text-accent'}`} />
          </div>
          <div>
            <h3 className="text-lg font-medium text-neutral-dark">{title}</h3>
            <p className="mt-2 text-sm text-gray-500">{message}</p>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button variant="outline" onClick={handleCancel}>
          {cancelText}
        </Button>
        <Button variant={variant} onClick={handleConfirm}>
          {confirmText}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
